export default "__VITE_ASSET__Biw$UBO9__"